"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CXoneNameValuePair = /** @class */ (function () {
    function CXoneNameValuePair(name, value) {
        this.Name = name;
        this.Value = value;
    }
    return CXoneNameValuePair;
}());
exports.default = CXoneNameValuePair;

//# sourceMappingURL=CXoneNameValuePair.js.map
